import React from 'react';
import { Link } from 'react-router-dom';
import './NavigationBar.css';

const NavigationBar = () => (
  <header>
    <div className="header-content display-row">
      <div className="logo">
        <Link to="/request"><img src="/images/wolken-logo.c2dc42f0ea3a9a44.png" alt="Wolken Logo" /></Link>
      </div>
      <div className="header-content-nav display-row">
        <nav>
          <ul className="display-row">
            <li>
              <span>Case Management</span>
              <ul className="nav-submenu">
                <li>
                  <Link to="/request" rel="noopener noreferrer">
                    <h5>Request</h5>
                    <p>Case Management</p>
                  </Link>
                </li>
                <li>
                  <Link to="/request_masters" rel="noopener noreferrer">
                    <h5>Masters</h5>
                    <p>Masters Management</p>
                  </Link>
                </li>
              </ul>
            </li>
            <li>
              <span>Docs [Case Management]</span>
              <ul className="nav-submenu">
                <li>
                  <Link to="/request/docs" rel="noopener noreferrer">
                    <h5>Request</h5>
                    <p>Case Management</p>
                  </Link>
                </li>
                <li>
                  <Link to="/request_masters/docs" rel="noopener noreferrer">
                    <h5>Masters</h5>
                    <p>Masters Management</p>
                  </Link>
                </li>
              </ul>
            </li>
            <li>
              <Link to="/get_apis" id="fetch-new-get-apis" rel="noopener noreferrer">
                Get APIs <span className="new-flash">NEW</span>
              </Link>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </header>
);

export default NavigationBar;
